import { useSubscription } from '@apollo/client';
import { GetThirdPartyResponseByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import type { FC } from 'react';

type Props = {
  responseId: string | undefined;
};

const Breadcrumb: FC<Props> = ({ responseId }) => {
  if (!responseId) {
    throw new Error('Missing id param');
  }

  const { data } = useSubscription(GetThirdPartyResponseByIdDocument, {
    variables: {
      Id: responseId,
    },
  });

  return (
    <>
      {`${
        data?.third_party_response_by_pk?.questionnaireTemplateVersion?.parent
          ?.Title
      } - ${data?.third_party_response_by_pk?.questionnaireTemplateVersion?.Version}`}
    </>
  );
};

export default Breadcrumb;
